import { $, $$, alcance, aviso, avisoHtml, esc, fecha, limpiar, noContesto, num, pedir, puede, rpc, sb, tengoRol, YO } from './nucleo';
import { RENGLONES } from './pedidos';
import { rotuloMoneda } from './cobros';

// ---------- aprobaciones ----------
//  Un módulo, no cinco casos (D23). La pantalla no sabe qué tipos existen:
//  los lee de `tipos_aprobacion` a través de la vista.
let APROBACIONES = [];

//  LO QUE NO SE PUDO LEER, por relación. Son DOS lecturas independientes
//  —avisos y solicitudes—: con una caída no se afirma nada ("No tenés avisos",
//  contador en 0, "No hay nada esperando tu decisión"…); se dice "no pude
//  leer" (regla del 4/9). Van por separado a propósito: cada una tiene su
//  cartel y su propio div.
let ERROR_AVISOS = '';
let ERROR_AP = '';

export async function cargarAprobaciones(){
  const [avisos, aps] = await Promise.all([
    pedir(sb.from('v_mis_notificaciones').select('*')
      .order('creada_en', { ascending: false }).limit(50)),
    pedir(sb.from('v_aprobaciones').select('*')
      .order('solicitado_en', { ascending: false }).limit(200))
  ]);

  ERROR_AVISOS = avisos.error ? avisos.error.message : '';
  ERROR_AP     = aps.error ? aps.error.message : '';

  pintarAvisos(avisos.data || []);

  APROBACIONES = aps.data || [];
  pintarPendientes();
  pintarMisSolicitudes();
  pintarHistorialAp();
}

function pintarAvisos(av){
  //  El botón NO se toca acá: tiene que seguir estando cuando la lectura
  //  falla (es el camino al reintento); lo cuida la prueba.

  if (ERROR_AVISOS){
    //  El contador NO dice 0. Un cero es un número leído y acá no se leyó
    //  nada (D83, D96); el «?» no se confunde con un número.
    $('#avisosN').textContent = '?';
    $('#btnAvisos').title = 'No se pudieron leer tus avisos';
    avisoHtml('#avisosLeerMsg','bad',
      `No pude leer tus avisos (${esc(ERROR_AVISOS)}). <b>No quiere decir que no ` +
      'tengas ninguno.</b> Cambiá de pestaña y volvé, o recargá con Ctrl+F5.');
    //  Y la tabla también afirma, así que también se desdice.
    $('#tblAvisos').innerHTML = '<tr><td colspan="3" class="vacio">' +
      `No se pudieron leer los avisos (${esc(ERROR_AVISOS)}). ` +
      'No quiere decir que no haya ninguno.</td></tr>';
    return;
  }
  //  Si la vuelta anterior falló y ésta anduvo, el cartel viejo se va y el
  //  título del botón vuelve al de siempre.
  limpiar('#avisosLeerMsg');
  $('#btnAvisos').title = 'Lo que te avisó el sistema';

  const sinLeer = av.filter(a => a.sin_leer).length;
  $('#avisosN').textContent = String(sinLeer);

  $('#tblAvisos').innerHTML = av.map(a => `
    <tr><td>${esc(fecha(a.creada_en))}</td>
        <td>${a.sin_leer ? '<b>' + esc(a.titulo) + '</b>' : esc(a.titulo)}</td>
        <td>${esc(a.cuerpo || '')}</td></tr>
  `).join('') || '<tr><td colspan="3" class="vacio">No tenés avisos</td></tr>';
}

//  EL ALCANCE DE `aprobacion.ver`, que no es el permiso que abre esta tarjeta
//  (D84 + D97). La lista sale de `v_aprobaciones`, cuyo RLS es
//  `alcance('aprobacion','ver') = 'todos' OR solicitado_por = yo`: quien
//  resuelve pero no ve todas recibe una lista RECORTADA, y "No hay nada
//  esperando tu decisión" sería falso.
//  El cartel dice CUÁL falta (D87): `alcance()` da null sin permiso, y el
//  nombre del alcance cuando lo hay.
function recorteDeVer(){
  const alc = alcance('aprobacion','ver');
  if (alc === 'todos') return '';
  return 'Esta lista trae <b>sólo tus propias solicitudes</b>: ' +
    (alc === null
      ? 'no tenés el permiso <span class="mono">aprobacion.ver</span>'
      : `tenés <span class="mono">aprobacion.ver</span> con alcance ` +
        `«${esc(alc)}» y no «todos»`) +
    '. Puede haber pedidos de otras personas esperando que esta pantalla no ve.';
}

//  SOY ADMIN, como `app.es_admin()` en la base: el rol, no un permiso.
//  `app.resolver_aprobacion` prohíbe resolver lo PROPIO salvo a quien
//  administra, y desde la 0071 (D164) administran tres roles: la lista es la
//  de `app.roles_de_administracion()`.
const ROLES_DE_ADMINISTRACION = ['admin', 'admin_global', 'dueno'];
export const soyAdmin = () => tengoRol(...ROLES_DE_ADMINISTRACION);

//  SOBRE QUÉ ES LA SOLICITUD, cuando no alcanza con el tipo y el motivo.
//  Marcar un equipo como no vendible (0055) lleva en `datos` producto, serie
//  y el ESTADO destino, que es lo que se autoriza: quien aprueba tiene que
//  ver A QUÉ dice que sí. Los pone la base, no el que pide.
export function detalleDe(a: any): string {
  const d = a?.datos || {};
  if (a?.tipo !== 'unidad_no_vendible') return '';
  return `${esc(d.producto || 'Equipo')} <span class="mono">${esc(d.serie || '—')}</span>`
    + ` → <b>${esc(d.estado_nombre || d.estado || '—')}</b>`;
}

function pintarPendientes(){
  if (!puede('aprobacion','resolver')) return;

  //  EL ALCANCE DE `resolver`, otro freno de la base.
  //  `app.resolver_aprobacion` arranca con:
  //      if coalesce(app.alcance(...), '') <> 'todos' then raise … 42501
  //  o sea: resolver es sobre TODAS o sobre NINGUNA. Con
  //  `aprobacion.resolver:propio` los botones rebotarían siempre: no se ofrecen.
  const alcResolver = alcance('aprobacion','resolver');
  if (alcResolver !== 'todos'){
    limpiar('#resLeerMsg');
    limpiar('#resAlcMsg');
    $('#listaPendientes').innerHTML = '<p class="vacio">' +
      `Tenés <span class="mono">aprobacion.resolver</span> con alcance ` +
      `«${esc(alcResolver)}» y no «todos», y resolver es sobre todas o sobre ` +
      'ninguna: la base no te va a dejar resolver ninguna, así que no se ' +
      'ofrece ningún botón.</p>';
    return;
  }

  if (ERROR_AP){
    //  En su propio div: `#resMsg` (Aprobar y Rechazar) lo limpia cada click.
    //  El del alcance se va: sin lista no se puede afirmar un recorte.
    avisoHtml('#resLeerMsg','bad',
      `No pude leer las solicitudes (${esc(ERROR_AP)}). <b>No quiere decir que no ` +
      'haya ninguna esperando tu decisión.</b> Cambiá de pestaña y volvé, o ' +
      'recargá con Ctrl+F5.');
    limpiar('#resAlcMsg');
    $('#listaPendientes').innerHTML = '<p class="vacio">' +
      `No se pudieron leer las solicitudes (${esc(ERROR_AP)}). ` +
      'No quiere decir que no haya ninguna.</p>';
    return;
  }
  limpiar('#resLeerMsg');

  const recorte = recorteDeVer();
  if (recorte) avisoHtml('#resAlcMsg','warn', recorte);
  else limpiar('#resAlcMsg');

  const f = APROBACIONES.filter(a => a.es_pendiente);
  $('#listaPendientes').innerHTML = f.map(a => `
    <div class="card" style="margin:0 0 0.588rem">
      <div class="grid g3">
        <div><div class="hint">Qué</div><b>${esc(a.tipo_nombre)}</b></div>
        <div><div class="hint">Quién</div>${esc(a.solicitante || '—')}</div>
        <div><div class="hint">Cuándo</div>${esc(fecha(a.solicitado_en))}</div>
      </div>
      ${detalleDe(a) ? `<div style="margin-top:0.471rem" data-detalle="${a.id}">
        <div class="hint">Sobre qué</div>${detalleDe(a)}</div>` : ''}
      <div style="margin-top:0.471rem"><div class="hint">Motivo</div>${esc(a.motivo)}</div>
      ${a.exige_monto ? `
        <div class="grid g3" style="margin-top:0.471rem">
          <div><div class="hint">Pide</div><b>${num(a.monto_solicitado)}</b></div>
          ${/*  EL CAMPO SALE DE `permite_parcial`, NO DE `exige_monto`: son
                columnas distintas ("lleva un número" vs "se puede aprobar
                menos"). `entrega_sin_pago` exige monto y NO admite parcial;
                ofrecer el campo sería rebotar en `resolver_aprobacion` (0043,
                D108). Sin campo, `resolver()` manda `p_monto_aprobado: null`
                y la base aprueba el monto entero.
                No hay tercera rama: `permite_parcial` es `not null` y el
                join con `tipos_aprobacion` es INTERNO. */''}
          ${a.permite_parcial ? `
          <label>Aprobar hasta
            <input type="number" step="0.01" min="0" data-monto="${a.id}"
                   value="${a.monto_solicitado}"></label>`
          : `
          <div data-entero="${a.id}"><div class="hint">Cuánto</div>
            Se aprueba <b>entero</b>: este tipo no admite aprobar menos.</div>`}
        </div>` : ''}
      <div class="grid" style="margin-top:0.471rem">
        <label>Comentario <span class="hint">obligatorio para rechazar</span>
          <input data-coment="${a.id}" placeholder="Lo va a leer quien lo pidió"></label>
      </div>
      ${a.solicitado_por === YO.id && !soyAdmin() ? `
        <p class="hint" data-propia="${a.id}" style="margin-top:0.471rem">
          Esta la pediste vos: la tiene que resolver otra persona.</p>` : `
      <div class="fila-acc" style="margin-top:0.471rem;gap:0.471rem">
        <button class="b" data-aprobar="${a.id}">Aprobar</button>
        <button class="b b-sec" data-rechazar="${a.id}">Rechazar</button>
      </div>`}
    </div>
  `).join('') || `<p class="vacio">${recorte
    //  El caso vacío tampoco afirma de más: con la lista recortada, "no hay
    //  nada esperando tu decisión" sería falso.
    ? 'No hay ninguna solicitud <b>tuya</b> pendiente. Las de las demás personas ' +
      'no se ven desde acá.'
    : 'No hay nada esperando tu decisión'}</p>`;

  $$('#listaPendientes button[data-aprobar]').forEach(b =>
    b.onclick = () => resolver(Number(b.dataset.aprobar), true, b));
  $$('#listaPendientes button[data-rechazar]').forEach(b =>
    b.onclick = () => resolver(Number(b.dataset.rechazar), false, b));
}

async function resolver(id, aprobar, btn){
  limpiar('#resMsg');
  const inMonto  = $(`[data-monto="${id}"]`);
  const inComent = $(`[data-coment="${id}"]`);
  btn.disabled = true;
  const { data, error } = await rpc('resolver_aprobacion', {
    p_id: id,
    p_aprobar: aprobar,
    p_comentario: (inComent && inComent.value.trim()) || null,
    p_monto_aprobado: inMonto && inMonto.value !== '' ? Number(inMonto.value) : null
  });
  btn.disabled = false;
  if (error){ aviso('#resMsg','bad', error.message); return; }
  aviso('#resMsg','ok', data.mensaje);
  cargarAprobaciones();
}

function pintarMisSolicitudes(){
  if (ERROR_AP){
    avisoHtml('#miasLeerMsg','bad',
      `No pude leer tus solicitudes (${esc(ERROR_AP)}). <b>No quiere decir que no ` +
      'hayas pedido ninguna.</b> Cambiá de pestaña y volvé, o recargá con Ctrl+F5.');
    $('#tblMias').innerHTML = '<tr><td colspan="6" class="vacio">' +
      `No se pudieron leer las solicitudes (${esc(ERROR_AP)}). ` +
      'No quiere decir que no haya ninguna.</td></tr>';
    return;
  }
  limpiar('#miasLeerMsg');

  const f = APROBACIONES.filter(a => a.solicitado_por === YO.id);
  const chip = e => e === 'aprobada' ? 'c-ok'
              : e === 'rechazada' ? 'c-bad'
              : e === 'cancelada' ? 'c-warn' : 'c-pen';
  $('#tblMias').innerHTML = f.map(a => `
    <tr><td>${esc(a.tipo_nombre)}${detalleDe(a) ? '<br><span class="hint">' + detalleDe(a) + '</span>' : ''}</td>
        <td>${esc(a.motivo)}${a.comentario ? '<br><span class="hint">' + esc(a.comentario) + '</span>' : ''}</td>
        <td class="num">${a.monto_solicitado != null ? num(a.monto_solicitado) : '—'}</td>
        <td class="num">${a.monto_aprobado != null ? '<b>' + num(a.monto_aprobado) + '</b>' : '—'}</td>
        <td><span class="chip ${chip(a.estado)}">${esc(a.estado)}</span>${
          a.vale_sin_usar ? ' <span class="hint">listo para usar</span>' : ''}</td>
        <td>${a.es_pendiente
          ? `<div class="fila-acc"><button class="b b-sec" data-baja="${a.id}">Dar de baja</button></div>`
          : ''}</td></tr>
  `).join('') || '<tr><td colspan="6" class="vacio">No pediste ninguna aprobación</td></tr>';

  $$('#tblMias button[data-baja]').forEach(b => b.onclick = async () => {
    limpiar('#miasMsg');
    b.disabled = true;
    const { data, error } = await rpc('cancelar_aprobacion',
      { p_id: Number(b.dataset.baja), p_comentario: null });
    b.disabled = false;
    if (error){ aviso('#miasMsg','bad', error.message); return; }
    aviso('#miasMsg','ok', data.mensaje);
    cargarAprobaciones();
  });
}

function pintarHistorialAp(){
  if (!puede('aprobacion','resolver')) return;

  if (ERROR_AP){
    avisoHtml('#histApMsg','bad',
      `No pude leer el historial (${esc(ERROR_AP)}). <b>No quiere decir que no se ` +
      'haya resuelto nada.</b>');
    $('#tblHistAp').innerHTML = '<tr><td colspan="7" class="vacio">' +
      `No se pudo leer el historial (${esc(ERROR_AP)}). ` +
      'No quiere decir que no haya nada resuelto.</td></tr>';
    return;
  }
  //  El mismo recorte que arriba: misma vista, con `aprobacion.ver` recortado
  //  son las resoluciones DE UNO.
  const recorte = recorteDeVer();
  if (recorte) avisoHtml('#histApMsg','warn', recorte);
  else limpiar('#histApMsg');

  const f = APROBACIONES.filter(a => !a.es_pendiente);
  $('#tblHistAp').innerHTML = f.map(a => `
    <tr><td>${esc(a.tipo_nombre)}</td>
        <td>${esc(a.solicitante || '—')}</td>
        <td class="num">${a.monto_solicitado != null ? num(a.monto_solicitado) : '—'}</td>
        <td class="num">${a.monto_aprobado != null ? num(a.monto_aprobado) : '—'}</td>
        <td>${esc(a.estado)}</td>
        <td>${esc(a.resolvio || '—')}</td>
        <td>${esc(fecha(a.resuelto_en))}</td></tr>
  `).join('') || `<tr><td colspan="7" class="vacio">${recorte
    ? 'No se resolvió ninguna solicitud <b>tuya</b>. Las de las demás personas no se ven desde acá.'
    : 'Todavía no se resolvió nada'}</td></tr>`;
}

$('#btnLeidas').onclick = async () => {
  limpiar('#apMsg');
  const { error } = await rpc('marcar_notificaciones_leidas', { p_ids: null });
  if (error){ aviso('#apMsg','bad', error.message); return; }
  cargarAprobaciones();
};

//  El puente entre el "no podés" y el "pedilo": cuando el alta de un pedido
//  se frena por un descuento fuera de política, acá abajo aparece el botón
//  para pedir la autorización sin salir de la pantalla.
//  Las dos frases con que la base frena un descuento: la primera la dicen las
//  funciones del renglón y del pedido entero; la segunda las distingue.
export const RECHAZO_DESCUENTO = 'supera el máximo preaprobado';
export const RECHAZO_DESCUENTO_PEDIDO = 'Descuento de pedido ';

export function ofrecerPedirAprobacion(mensajeDeError){
  //  LA TARJETA VIEJA SE VA PRIMERO, pase lo que pase: si se borrara sólo en
  //  el camino que la recrea, quedaría con botones vivos por un renglón que
  //  ya no existe.
  const viejo = document.getElementById('cardPedirAp');
  if (viejo) viejo.remove();

  //  LA TARJETA SALE DEL RECHAZO QUE LE CORRESPONDE, no de cualquiera que
  //  nombre una aprobación: en la base hay CINCO rechazos así y piden tipos
  //  distintos (`validar_descuento_item` → `descuento_item`, el único de esta
  //  tarjeta; `validar_descuento_pedido` → `descuento_pedido`, sobre el pedido entero;
  //  `validar_reserva`, `validar_cancelacion_reserva`, `exigir_corte`).
  //  Es texto, como el del vale (esos `raise` no llevan `errcode`); las dos
  //  constantes se cotejan contra `prosrc` en `scripts/cotejar-catalogos.py`.
  const m = mensajeDeError || '';
  //  0100 (D219) · el corte del día: la carga se pide sin referencia
  //  («carga», como dice `app.crear_pedido`). Antes el rechazo mandaba a
  //  «Aprobaciones», donde no había forma de pedirla.
  if (ofrecerPedirCorte({ despuesDe: '#pedMsg', id: 'cardPedirCorte', prefijo: 'apCorte',
        mensaje: m, refTipo: 'carga', refId: null,
        comoSigue: 'Cuando te la den, volvé a apretar «Confirmar pedido».' })) return;
  if (!m.includes(RECHAZO_DESCUENTO)) return;
  //  El del pedido entero dice lo mismo con otro sujeto: sólo se separa por el prefijo.
  if (m.includes(RECHAZO_DESCUENTO_PEDIDO)) return;
  const conDesc = RENGLONES.filter(r => Number(r.descuento) > 0);
  if (!conDesc.length) return;

  const html = `
    <div class="card" id="cardPedirAp" style="margin-top:0.588rem">
      <h2>Pedir autorización</h2>
      <p class="hint">Se le avisa a quien puede autorizarlo. Cuando te
         respondan, volvés a confirmar el pedido. <b>Ojo: te lo tienen que
         autorizar por el descuento entero</b> — si te autorizan menos, bajá
         el descuento a ese número, porque con el de ahora el pedido se frena
         igual.</p>
      <label>Por qué <input id="apMotivo" placeholder="Ej. el cliente lleva cuatro y lo tenemos que igualar"></label>
      <div class="fila-acc" style="margin-top:0.471rem;gap:0.471rem;flex-wrap:wrap">
        ${conDesc.map((r,i) => `<button class="b" data-pedirap="${i}">Pedir ${num(r.descuento)} en ${esc(r.codigo)}</button>`).join('')}
      </div>
      <div id="apPedMsg"></div>
    </div>`;
  $('#pedMsg').insertAdjacentHTML('afterend', html);

  $$('#cardPedirAp [data-pedirap]').forEach(b => b.onclick = async () => {
    const r = conDesc[Number(b.dataset.pedirap)];
    const motivo = ($('#apMotivo').value || '').trim();
    limpiar('#apPedMsg');
    if (!motivo){ aviso('#apPedMsg','bad','Escribí por qué: es lo que va a leer quien autoriza.'); return; }
    //  El cliente va adentro del `jsonb`, sin clave foránea que lo frene:
    //  `Number('')` es NaN y se guarda como null (autorización para nadie).
    if (!$('#peCliente').value){
      aviso('#apPedMsg','bad','Elegí el cliente del pedido antes de pedir la autorización.');
      return;
    }
    b.disabled = true;
    const { data, error } = await rpc('pedir_aprobacion', {
      p_tipo: 'descuento_item',
      p_motivo: motivo,
      p_monto: Number(r.descuento),
      p_referencia_tipo: null,
      p_referencia_id: null,
      //  Lo frena el `if` de arriba (`Number('')` es NaN).
      p_datos: { cliente_id: Number($('#peCliente').value), producto_id: r.producto_id }
    });
    //  EL BOTÓN NO VUELVE SI LA BASE NO CONTESTÓ (D91, D92): pedir CREA una
    //  fila y quizá ya existe. No va por `trabarSiNoContesto` (para botones
    //  FIJOS del HTML; ver `nucleo.ts`): esta tarjeta nace de nuevo en cada
    //  error de alta, alcanza con no encenderlo.
    //  Y SE APAGAN TODOS, no sólo el apretado: con dos renglones hay dos
    //  botones y UN SOLO `#apPedMsg`; uno vivo pintaría un aviso verde junto
    //  a un botón apagado. La tarjeta ENTERA queda en duda hasta reintentar el alta.
    if (noContesto(error)) $$('#cardPedirAp [data-pedirap]').forEach(x => x.disabled = true);
    else b.disabled = false;
    if (error){ aviso('#apPedMsg','bad', error.message); return; }
    aviso('#apPedMsg','ok', data.mensaje);
    cargarAprobaciones();
  });
}


// ---------------------------------------------------------------------
//  EL CORTE DEL DÍA (0100, D219)
// ---------------------------------------------------------------------
//  Después del corte, cargar un pedido o anular un ítem pide un vale
//  `fuera_de_horario`, y la base lo rechaza con esta frase (cotejada contra
//  `app.exigir_corte` en `scripts/cotejar-catalogos.py`). Hasta la 0100 el
//  rechazo decía «pedila desde Aprobaciones» y en Aprobaciones no había cómo:
//  la tarjeta aparece donde se frenó. El admin global no la ve nunca: la
//  base lo deja pasar directo.
export const RECHAZO_CORTE = 'después de esa hora necesita autorización';

//  Dibuja la tarjeta si el rechazo es el del corte, y dice si la dibujó. Se
//  pega DESPUÉS de `despuesDe` con el id `id`; la vieja (mismo id) se va
//  primero, pase lo que pase.
export function ofrecerPedirCorte(o: {
  despuesDe: string;          // el cartel donde la pantalla escribió el rechazo
  id: string;                 // id de la tarjeta, para borrarla al reintentar
  prefijo: string;            // para que los ids de dos pantallas no choquen
  mensaje: string;            // el rechazo, tal cual lo dijo la base
  refTipo: 'carga' | 'pedido_item' | 'pedido';
  refId: number | null;       // el ítem o la venta (cancelarla, 0102); null si es cargar
  comoSigue: string;          // literal del repo: qué hacer cuando respondan
}): boolean {
  document.getElementById(o.id)?.remove();
  if (!(o.mensaje || '').includes(RECHAZO_CORTE)) return false;
  //  Anular se pide sobre el ítem: sin él, `pedir_aprobacion` rechaza.
  if (o.refTipo !== 'carga' && !o.refId) return false;
  const p = o.prefijo;
  $(o.despuesDe).insertAdjacentHTML('afterend', `
    <div class="confirmar grave" id="${o.id}" style="margin-top:0.471rem">
      <div class="conf-tit">Pedir autorización por el corte del día</div>
      <p class="conf-txt">Se le avisa a quien puede autorizarlo. ${esc(o.comoSigue)}</p>
      <label>Por qué
        <input id="${p}Motivo" placeholder="Ej. el cliente confirmó recién y lo pasa a buscar mañana"></label>
      <div class="fila-acc" style="margin-top:0.471rem">
        <button class="b b-pri" id="${p}Ok">Pedir autorización</button>
      </div>
      <div id="${p}Msg"></div>
    </div>`);
  const tarjeta = document.getElementById(o.id);
  $(`#${p}Ok`).onclick = async () => {
    const motivo = ($(`#${p}Motivo`).value || '').trim();
    limpiar(`#${p}Msg`);
    if (!motivo) return aviso(`#${p}Msg`,'bad','Escribí por qué: es lo que va a leer quien autoriza.');
    $(`#${p}Ok`).disabled = true;
    const { data, error } = await rpc('pedir_aprobacion', {
      p_tipo: 'fuera_de_horario',
      p_motivo: motivo,
      p_monto: null,
      p_referencia_tipo: o.refTipo,
      p_referencia_id: o.refId,
      p_datos: {}
    });
    //  La guarda de viaje (como `ofrecerVale`): la tarjeta pudo irse
    //  mientras se esperaba; el resultado se cuenta en el cartel del rechazo.
    if (!tarjeta?.isConnected)
      return aviso(o.despuesDe, error ? 'bad' : 'ok',
        'La autorización por el corte que estabas pidiendo: ' +
        (error ? error.message : (data?.mensaje || 'pedida. Esperá la respuesta.')));
    //  Pedir CREA una fila: si la base no contestó, el botón no vuelve (D91, D92).
    const sinRespuesta = noContesto(error);
    if (!sinRespuesta) $(`#${p}Ok`).disabled = false;
    if (error) return aviso(`#${p}Msg`,'bad', error.message);
    aviso(`#${p}Msg`,'ok', data?.mensaje ?? 'Pedido. Esperá la respuesta.');
    cargarAprobaciones();
  };
  return true;
}


// ---------------------------------------------------------------------
//  EL VALE DE «ENTREGAR SIN COBRAR»
// ---------------------------------------------------------------------
//  `app.cambiar_estado_item` llama a `app.exigir_pago_del_item` cuando el
//  estado destino tiene `exige_cobro` (hoy `entregado`), y esa puerta la
//  cruzan TRES transiciones:
//
//    · `en_transito → entregado`, del motoquero, que es la de la calle;
//    · `empaquetado → entregado`, del cajero y de logística;
//    · `verificado  → entregado`, del cajero, sólo para los de `retiro`.
//
//  Las dos últimas se aprietan desde el CIRCUITO (mostrador), así que el
//  vale lo usan las dos pantallas.
//
//  ESTÁ ACÁ Y NO COPIADO EN LAS DOS PANTALLAS (D109): lo que decide si la
//  tarjeta aparece es una FRASE de la base, cotejada contra `prosrc` en
//  `scripts/cotejar-catalogos.py` (CI), que sólo mira una copia. Vale igual
//  para el regex del monto y la guarda de abajo. Lo que cambia entre
//  pantallas (dónde se pinta, qué hacer después) entra por parámetro.
export const CONSEJO_VALE = 'pedí la autorización y esperá la respuesta';

//  El monto que el vale va a pedir, o null si esta tarjeta no corresponde.
//  Son DOS preguntas y las dos tienen que dar que sí:
//
//   1 · que el rechazo sea el que el vale destraba. De los rechazos de plata
//       o autorizaciones, en tres el vale no arregla nada (cobrar de MÁS,
//       «no tiene cliente asignado», el del corte). Lo que separa al bueno es
//       la frase con que la base ACONSEJA pedirlo, sólo en las dos ramas de
//       `app.exigir_pago_del_item`.
//   2 · que traiga el número: `entrega_sin_pago` tiene `exige_monto` y
//       `app.pedir_aprobacion` rechaza `p_monto` nulo. Hoy es inalcanzable
//       (el cotejo lo garantiza); queda como lado seguro. La `i` del regex
//       evita quedarse sin monto por una mayúscula.
export function montoDelVale(mensaje: string): number | null {
  if (!(mensaje || '').includes(CONSEJO_VALE)) return null;
  const monto = Number((mensaje.match(/falta cobrar ([\d.]+)/i) || [])[1]);
  return Number.isFinite(monto) && monto > 0 ? monto : null;
}

//  Dibuja la tarjeta si corresponde, y dice si la dibujó, para que la pantalla
//  la borre cuando deje de corresponder (D108).
//
//  `comoSigue` es HTML con literales del repo; el mensaje de la base no se
//  pinta acá (lo pinta quien llama, con `aviso()`, que escapa).
export function ofrecerVale(o: {
  contenedor: string;            // dónde se agrega la tarjeta
  prefijo: string;               // para que los ids de las dos pantallas no choquen
  pedidoId: number | null | undefined;
  mensaje: string;               // el rechazo, tal cual lo dijo la base
  comoSigue: string;             // qué tiene que hacer cuando le respondan
  //  Dónde se cuenta el resultado si la tarjeta ya no está (guarda de viaje,
  //  abajo): un cartel FIJO del HTML, que no se repinte.
  cartelSuelto: string;
}): boolean {
  const monto = montoDelVale(o.mensaje);
  //  SIN PEDIDO NO SE OFRECE: `app.pedir_aprobacion` valida la referencia
  //  contra `app.pedido_es_mio`. Las pantallas capturan el id ANTES del `await`.
  if (monto == null || !o.pedidoId) return false;
  const pedidoId = o.pedidoId, p = o.prefijo;

  $(o.contenedor).insertAdjacentHTML('beforeend', `
    <div class="confirmar grave" style="margin-top:0.471rem">
      <div class="conf-tit">Pedir autorización para entregar sin cobrar</div>
      <p class="conf-txt">Se le avisa a quien puede autorizarlo. Tienen que
         autorizarte <b>al menos ${num(monto)} ${esc(rotuloMoneda())}</b>: con
         menos, la entrega se frena igual. ${o.comoSigue}</p>
      <label>Qué está pasando
        <input id="${p}Motivo" placeholder="dice que paga por transferencia mañana"></label>
      <div class="fila-acc" style="margin-top:0.471rem">
        <button class="b b-pri" id="${p}Ok">Pedir la autorización</button>
      </div>
      <div id="${p}Msg"></div>
    </div>`);

  //  El nodo de la tarjeta, guardado al crearla: la guarda de viaje pregunta
  //  "¿sigue estando LA MÍA?", no "¿hay una tarjeta?".
  const tarjeta = $(`#${p}Ok`).closest('.confirmar');

  $(`#${p}Ok`).onclick = async () => {
    const motivo = ($(`#${p}Motivo`).value || '').trim();
    limpiar(`#${p}Msg`);
    if (!motivo) return aviso(`#${p}Msg`,'bad','Escribí qué está pasando: es lo que va a leer quien autoriza.');
    $(`#${p}Ok`).disabled = true;
    const { data, error } = await rpc('pedir_aprobacion', {
      p_tipo: 'entrega_sin_pago',
      p_motivo: motivo,
      p_monto: monto,
      p_referencia_tipo: 'pedido',
      p_referencia_id: pedidoId,
      p_datos: {}
    });
    //  LA GUARDA DE VIAJE. Hasta SIETE segundos (D92) entre click y respuesta:
    //  la tarjeta pudo irse (Vueltas: se cerró la parada; Circuito:
    //  `caducarVale()` o `mover()` borran su div). Sin la guarda `$()` da null
    //  y el TypeError MATA el handler, perdiendo el «no se sabe si quedó hecho»
    //  (D91). Si ya no está, el resultado se cuenta igual en el cartel FIJO.
    if (!tarjeta || !tarjeta.isConnected)
      return aviso(o.cartelSuelto, error ? 'bad' : 'ok',
        'La autorización para entregar sin cobrar que estabas pidiendo: ' +
        (error ? error.message : (data?.mensaje || 'pedida. Esperá la respuesta.')));

    //  Como el botón de Pedidos: pedir CREA una fila, si la base no contestó el
    //  botón no vuelve. No va por `trabarSiNoContesto` (botones FIJOS del
    //  HTML); la tarjeta nace de nuevo en cada rechazo (regla 76).
    if (!noContesto(error)) $(`#${p}Ok`).disabled = false;
    if (error) return aviso(`#${p}Msg`,'bad', error.message);
    aviso(`#${p}Msg`,'ok', data?.mensaje || 'Pedido. Esperá la respuesta.');
    cargarAprobaciones();
  };
  return true;
}
